import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer, colorBins } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const BROWARDMTPRESILIENCEROADNETWORK_LAYER_ID =
  'browardMTPResilienceRoadNetworkLayer';

const layerConfig = {
  title: 'Broward MTP Resilience Road Network',
};

function BrowardMTPResilienceRoadNetworkLayer() {
  const dispatch = useDispatch();
  const { browardMTPResilienceRoadNetworkLayer } = useSelector(
    (state) => state.carto.layers
  );
  const source = useSelector((state) =>
    selectSourceById(state, browardMTPResilienceRoadNetworkLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardMTPResilienceRoadNetworkLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDMTPRESILIENCEROADNETWORK_LAYER_ID,
      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardMTPResilienceRoadNetworkLayer.visible,
      opacity: browardMTPResilienceRoadNetworkLayer.opacity,
      getLineColor: colorBins({
        attr: 'ResScore50',
        domain: [2.99, 4, 4.01, 5, 6, 7, 10],
        colors: [
          [25, 57, 138],
          [241, 100, 119],
          [231, 166, 20],
          [0, 158, 88],
          [255, 153, 167],
          [128, 0, 128],
          [75, 0, 130],
        ],
      }),
      pointRadiusMinPixels: 5,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDMTPRESILIENCEROADNETWORK_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              //   includeColumns: ['geo_level_id', 'job_access_30minute_transit_diff'],
            }),
          };
        }
      },
    });
  }
}

export default BrowardMTPResilienceRoadNetworkLayer;
